import useUiTranslation from 'src/hooks/useUiTranslation';

const useValidatePassword = () => {
  const { tPages } = useUiTranslation();

  return {
    minLength: (value: string) =>
      value.length >= 8 ||
      tPages('changePassword.validatePasswordMessage.minLength'),
    hasUpperCase: (value: string) =>
      /[A-Z]/.test(value) ||
      tPages('changePassword.validatePasswordMessage.hasUpperCase'),
    hasLowerCase: (value: string) =>
      /[a-z]/.test(value) ||
      tPages('changePassword.validatePasswordMessage.hasLowerCase'),
    hasNumber: (value: string) =>
      /\d/.test(value) ||
      tPages('changePassword.validatePasswordMessage.hasNumber'),
    hasSpecialChar: (value: string) =>
      /[!@#$%^&*()_+\-={}[\]:";'<>,./]/.test(value) ||
      tPages('changePassword.validatePasswordMessage.hasSpecialChar'),
  };
};

export default useValidatePassword;
